import { PhotoshopController } from "../photoshopController.js";

export class ToolsPanelWidget {
    parentElement: HTMLElement;
    photoshopController: PhotoshopController;
    updateIfCallback: any;
    updateModelCallback: any;
    size: HTMLElement | null;
    constructor(parentElement: HTMLElement, controller: PhotoshopController, updateIfCallback: any, updateModelCallback: any) {
        this.parentElement = parentElement;
        this.photoshopController = controller;
        this.updateIfCallback = updateIfCallback;
        this.updateModelCallback = updateModelCallback;

        const polygonalTool = document.getElementById("polygonal-selection-tool");
        if (polygonalTool) {
            polygonalTool.addEventListener("click", function () {
                this.polygonal_selection_toolOnClick();
                this.updateIfCallback();
                this.updateClass();
            }.bind(this));
        }

        const rectangularTool = document.getElementById("rectangular-selection-tool");
        if (rectangularTool) {
            rectangularTool.addEventListener("click", function () {
                this.rectangular_selection_toolOnClick();
                this.updateIfCallback();
                this.updateClass();
            }.bind(this));
        }

        const eyeDropperTool = document.getElementById("eyeDropper-selection-tool");
        if (eyeDropperTool) {
            eyeDropperTool.addEventListener("click", function () {
                this.eyeDropper_selection_toolOnClick();
                this.updateIfCallback();
                this.updateClass();
            }.bind(this));
        }

        const brushTool = document.getElementById("brush-selection-tool");
        if (brushTool) {
            brushTool.addEventListener("click", function () {
                this.brush_selection_toolOnClick();
                this.updateIfCallback();
                this.updateClass();
            }.bind(this));
        }

        const eraserTool = document.getElementById("eraser-selection-tool");
        if (eraserTool) {
            eraserTool.addEventListener("click", function () {
                this.eraser_selection_toolOnClick();
                this.updateIfCallback();
                this.updateClass();
            }.bind(this));
        }

        const densityPlusTool = document.getElementById("density-plus-selection-tool");
        if (densityPlusTool) {
            densityPlusTool.addEventListener("click", function () {
                this.density_plus_selection_toolOnClick();
                this.updateIfCallback();
                this.updateClass();
            }.bind(this));
        }

        const densityLowTool = document.getElementById("density-low-selection-tool");
        if (densityLowTool) {
            densityLowTool.addEventListener("click", function () {
                this.density_low_selection_toolOnClick();
                this.updateIfCallback();
                this.updateClass();
            }.bind(this));
        }

        const stampTool = document.getElementById("stamp-selection-tool");
        if (stampTool) {
            stampTool.addEventListener("click", function () {
                this.stamp_selection_toolOnClick();
                this.updateIfCallback();
                this.updateClass();
            }.bind(this));
        }

        const verticalRotationTool = document.getElementById("vertical-rotation-selection-tool");
        if (verticalRotationTool) {
            verticalRotationTool.addEventListener("click", function () {
                this.vertical_rotation_selection_toolOnClick();
                this.updateIfCallback();
                this.updateModelCallback();
                this.updateClass();
            }.bind(this));
        }

        const horizontalRotationTool = document.getElementById("horizontal-rotation-selection-tool");
        if (horizontalRotationTool) {
            horizontalRotationTool.addEventListener("click", function () {
                this.horizontal_rotation_selection_toolOnClick();
                this.updateIfCallback();
                this.updateModelCallback();
                this.updateClass();
            }.bind(this));
        }

        const rotationZTool = document.getElementById("rotationZ-selection-tool");
        if (rotationZTool) {
            rotationZTool.addEventListener("click", function () {
                this.rotationZ_selection_toolOnClick();
                this.updateIfCallback();
                this.updateModelCallback();
                this.updateClass();
            }.bind(this));
        }

        const selectiveCorrectionTool = document.getElementById("selective-correction-tool");
        if (selectiveCorrectionTool) {
            selectiveCorrectionTool.addEventListener("click", function() {
                this.selective_correction_toolOnClick();
                this.updateIfCallback();
                this.updateModelCallback();
                this.updateClass();
            }.bind(this));
        }
    }

    static html() {
        return `
        <div style="float:left; width: 100px; margin: 10px;">
            <div id="polygonal-selection-tool" class="center-align tool" title="Sélection polygonale">
                <i class="fas fa-draw-polygon"></i>
            </div>
            <div id="rectangular-selection-tool" class="center-align tool" title="Sélection rectangulaire">
                <i class="far fa-square"></i>
            </div>
            <div id="eyeDropper-selection-tool" class="center-align tool" title="Pipette">
                <i class="fas fa-eye-dropper"></i>
            </div>
            <div id="brush-selection-tool" class="center-align tool" title="Pinceau">
                <i class="fas fa-paint-brush"></i>
            </div>
            <div id="eraser-selection-tool" class="center-align tool" title="Gomme">
                <i class="fas fa-eraser"></i>
            </div>
            <div id="density-plus-selection-tool" class="center-align tool" title="Densité +">
                <i class="fas fa-search-plus"></i>
            </div>
            <div id="density-low-selection-tool" class="center-align tool" title="Densité -">
                <i class="fas fa-search-minus"></i>
            </div>
            <div id="stamp-selection-tool" class="center-align tool" title="Tampon">
                <i class="fas fa-stamp"></i>
            </div>
            <div id="vertical-rotation-selection-tool" class="center-align tool" title="Rotation verticale">
                <i class="fas fa-arrows-alt-v"></i>
            </div>
            <div id="horizontal-rotation-selection-tool" class="center-align tool" title="Rotation horizontale">
                <i class="fas fa-arrows-alt-h"></i>
            </div>
            <div id="rotationZ-selection-tool" class="center-align tool" title="Rotation">
                <i class="fas fa-sync-alt"></i>
            </div>
            <div id="selective-correction-tool" class="center-align tool" title="Correction sélective">
                <i class="fas fa-swatchbook"></i>
            </div>
            <div style="clear: both; margin-top: 10px; width: 100%; display: inline-block;">
                <div style="width: 40px; height: 40px; margin: auto; border: 1px solid white; background-color: #fff;">
                    <div id="selected-color" style="width: 100%; height: 100%;"></div>
                </div>
            </div>
        </div>
        `;
    }

    polygonal_selection_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.selection.active = (!this.photoshopController.PSEngine.selection.activated || this.photoshopController.PSEngine.selection.mode !== 0);
        this.photoshopController.PSEngine.selection.mode = 0;
        this.photoshopController.PSEngine.selection.clear();
        this.photoshopController.update();
        this.photoshopController.PSEngine.pipette.active = false;
        this.photoshopController.setActiveOperation(null);
        this.photoshopController.PSRotationMode = null;
    }

    rectangular_selection_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.selection.active = (!this.photoshopController.PSEngine.selection.activated || this.photoshopController.PSEngine.selection.mode !== 1);
        this.photoshopController.PSEngine.selection.mode = 1;
        this.photoshopController.PSEngine.selection.clear();
        this.photoshopController.update();
        this.photoshopController.PSEngine.pipette.active = false;
        this.photoshopController.setActiveOperation(null);
        this.photoshopController.PSRotationMode = null;
    }

    eyeDropper_selection_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.pipette.active = !this.photoshopController.PSEngine.pipette.activated;
        this.photoshopController.PSEngine.selection.active = false;
        this.photoshopController.setActiveOperation(null);
        this.photoshopController.PSRotationMode = null;
    }

    brush_selection_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.setActiveOperation('brush');
        this.photoshopController.PSRotationMode = null;
        this.size = document.getElementById("tool-setting-size");
        if (this.size) {
            this.size.innerHTML = this.photoshopController.PSEngine.activeOperation.size;
        }
    }

    eraser_selection_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.setActiveOperation('gum');
        this.photoshopController.PSRotationMode = null;
        this.size = document.getElementById("tool-setting-size");
        if (this.size) {
            this.size.innerHTML = this.photoshopController.PSEngine.activeOperation.size;
        }
    }

    density_plus_selection_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.setActiveOperation('density');
        this.photoshopController.PSEngine.activeOperation.plus = true;
        this.photoshopController.PSRotationMode = null;
        this.size = document.getElementById("tool-setting-size");
        if (this.size) {
            this.size.innerHTML = this.photoshopController.PSEngine.activeOperation.size;
        }
    }

    density_low_selection_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.setActiveOperation('density');
        this.photoshopController.PSEngine.activeOperation.plus = false;
        this.photoshopController.PSRotationMode = null;
        this.size = document.getElementById("tool-setting-size");
        if (this.size) {
            this.size.innerHTML = this.photoshopController.PSEngine.activeOperation.size;
        }
    }

    stamp_selection_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.setActiveOperation('stamp');
        this.photoshopController.PSRotationMode = null;
        this.size = document.getElementById("tool-setting-size");
        if (this.size) {
            this.size.innerHTML = this.photoshopController.PSEngine.activeOperation.size;
        }
    }

    vertical_rotation_selection_toolOnClick() {
        this.photoshopController.PSRotationMode !== 'X' ? this.photoshopController.PSRotationMode = 'X' : this.photoshopController.PSRotationMode = null;
        this.photoshopController.setActiveOperation(null);
        const rotationValue = this.photoshopController.layerRotation();
        const rotationInput = document.getElementById("tool-setting-rotation-input-button") as HTMLInputElement | null;
        if (rotationInput) {
            rotationInput.value = rotationValue !== undefined ? rotationValue.toString() : "";
        }
    }

    horizontal_rotation_selection_toolOnClick() {
        this.photoshopController.PSRotationMode !== 'Y' ? this.photoshopController.PSRotationMode = 'Y' : this.photoshopController.PSRotationMode = null;
        this.photoshopController.setActiveOperation(null);
        const rotationValue = this.photoshopController.layerRotation();
        const rotationInput = document.getElementById("tool-setting-rotation-input-button") as HTMLInputElement | null;
        if (rotationInput) {
            rotationInput.value = rotationValue !== undefined ? rotationValue.toString() : "";
        }
    }

    rotationZ_selection_toolOnClick() {
        this.photoshopController.PSRotationMode !== 'Z' ? this.photoshopController.PSRotationMode = 'Z' : this.photoshopController.PSRotationMode = null;
        this.photoshopController.setActiveOperation(null);
        const rotationValue = this.photoshopController.layerRotation();
        const rotationInput = document.getElementById("tool-setting-rotation-input-button") as HTMLInputElement | null;
        if (rotationInput) {
            rotationInput.value = rotationValue !== undefined ? rotationValue.toString() : "";
        }
    }

    selective_correction_toolOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.setActiveOperation('selectiveCorrection');
    }

    updateClass() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.selection.activated && this.photoshopController.PSEngine.selection.mode === 0) {
            const polygonalToolElem = document.getElementById("polygonal-selection-tool");
            if (polygonalToolElem) {
                polygonalToolElem.classList.add('selected-tool');
            }
        } else {
            const polygonalToolElem = document.getElementById("polygonal-selection-tool");
            if (polygonalToolElem) {
                polygonalToolElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.selection.activated && this.photoshopController.PSEngine.selection.mode === 1) {
            const rectangularToolElem = document.getElementById("rectangular-selection-tool");
            if (rectangularToolElem) {
                rectangularToolElem.classList.add('selected-tool');
            }
        } else {
            const rectangularToolElem = document.getElementById("rectangular-selection-tool");
            if (rectangularToolElem) {
                rectangularToolElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.pipette.activated) {
            const eyeDropperToolElem = document.getElementById("eyeDropper-selection-tool");
            if (eyeDropperToolElem) {
                eyeDropperToolElem.classList.add('selected-tool');
            }
        } else {
            const eyeDropperToolElem = document.getElementById("eyeDropper-selection-tool");
            if (eyeDropperToolElem) {
                eyeDropperToolElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.name === 'Pinceau') {
            const brushToolElem = document.getElementById("brush-selection-tool");
            if (brushToolElem) {
                brushToolElem.classList.add('selected-tool');
            }
        } else {
            const brushToolElem = document.getElementById("brush-selection-tool");
            if (brushToolElem) {
                brushToolElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.name === 'Gomme') {
            const eraserToolElem = document.getElementById("eraser-selection-tool");
            if (eraserToolElem) {
                eraserToolElem.classList.add('selected-tool');
            }
        } else {
            const eraserToolElem = document.getElementById("eraser-selection-tool");
            if (eraserToolElem) {
                eraserToolElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'density' && this.photoshopController.PSEngine.activeOperation.plus === true) {
            const densityPlusElem = document.getElementById("density-plus-selection-tool");
            if (densityPlusElem) {
                densityPlusElem.classList.add('selected-tool');
            }
        } else {
            const densityPlusElem = document.getElementById("density-plus-selection-tool");
            if (densityPlusElem) {
                densityPlusElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'density' && this.photoshopController.PSEngine.activeOperation.plus === false) {
            const densityLowElem = document.getElementById("density-low-selection-tool");
            if (densityLowElem) {
                densityLowElem.classList.add('selected-tool');
            }
        } else {
            const densityLowElem = document.getElementById("density-low-selection-tool");
            if (densityLowElem) {
                densityLowElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'stamp') {
            const stampToolElem = document.getElementById("stamp-selection-tool");
            if (stampToolElem) {
                stampToolElem.classList.add('selected-tool');
            }
        } else {
            const stampToolElem = document.getElementById("stamp-selection-tool");
            if (stampToolElem) {
                stampToolElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSRotationMode === 'X') {
            const verticalRotationElem = document.getElementById("vertical-rotation-selection-tool");
            if (verticalRotationElem) {
                verticalRotationElem.classList.add('selected-tool');
            }
        } else {
            const verticalRotationElem = document.getElementById("vertical-rotation-selection-tool");
            if (verticalRotationElem) {
                verticalRotationElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSRotationMode === 'Y') {
            const horizontalRotationElem = document.getElementById("horizontal-rotation-selection-tool");
            if (horizontalRotationElem) {
                horizontalRotationElem.classList.add('selected-tool');
            }
        } else {
            const horizontalRotationElem = document.getElementById("horizontal-rotation-selection-tool");
            if (horizontalRotationElem) {
                horizontalRotationElem.classList.remove('selected-tool');
            }
        }
        if (this.photoshopController.PSRotationMode === 'Z') {
            const rotationZToolElem = document.getElementById("rotationZ-selection-tool");
            if (rotationZToolElem) {
                rotationZToolElem.classList.add('selected-tool');
            }
        } else {
            const rotationZToolElem = document.getElementById("rotationZ-selection-tool");
            if (rotationZToolElem) {
                rotationZToolElem.classList.remove('selected-tool');
            }
        }
    }
}